module.exports = __webpack_public_path__ + "static/media/Copy of Tron8.4e7e8276.jpg";